<template>
  <portal :to="getPortalTitle">
    <img
      alt=""
      class="authority-service-logo"
      src="/svg/authority-services/did-logo.svg"
    />
  </portal>

  <portal v-if="!webIdentUrl" :to="getPortalSubtitle">
    <div class="font-weight-semibold text-body-large mb-4">
      {{ i18n.t('titles.check_identity') }}
    </div>
    <div class="mb-6">
      {{
        display.smAndDown.value && !showQr
          ? i18n.t('texts.check_identity_did_hint_mobile')
          : i18n.t('texts.check_identity_did_hint')
      }}
    </div>
  </portal>

  <DeepIdWebFrame
    v-if="webIdentUrl"
    :show-footer="false"
    :url="webIdentUrl"
    @done="webIdentUrl = undefined"
  />
  <div v-else>
    <GetDeepIDCard
      v-if="display.mdAndUp.value || showQr"
      @open-web-ident="webIdentUrl = $event"
    />
    <MobileDeepIDSigningCard v-else-if="!showQr" @show-qr="showQr = true" />
  </div>
  <portal v-if="webIdentUrl" :to="getPortalActions">
    <DeepIdWebFooter class="w-100" />
  </portal>
  <portal v-else :to="getPortalActions">
    <component
      :is="display.smAndDown.value && !showQr ? 'VBtnSecondary' : 'VBtnPrimary'"
      :text="i18n.t('buttons.cancel')"
      @click="closeDialog"
    />
    <VBtnPrimary
      v-if="display.smAndDown.value && !showQr"
      color="primary"
      :text="i18n.t('buttons.download')"
      @click="getApp"
    />
  </portal>
</template>

<script setup lang="ts">
import MobileDeepIDSigningCard from '@/components/cards/MobileDeepIDSigningCard.vue';
import GetDeepIDCard from '@/components/cards/GetDeepIDCard.vue';
import DeepIdWebFrame from '@/components/cards/DeepIdWebFrame.vue';
import DeepIdWebFooter from '@/components/cards/DeepIdWebFooter.vue';
import { useDeepAdminInternalStore } from '@/stores/deepadmin/deepadmin-internal';
import { useI18n } from 'vue-i18n';
import { computed, onBeforeUnmount, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useDisplay } from 'vuetify/framework';
const emit = defineEmits(['close-dialog', 'web-ident-change']);

const deepAdminInternalStore = useDeepAdminInternalStore();
const display = useDisplay();
const i18n = useI18n();
const showQr = ref(false);
const webIdentUrl = ref<string>();

// lets the hosting dialog keep itself open against stray backdrop clicks while DeepID is shown
watch(webIdentUrl, (url) => emit('web-ident-change', !!url));
onBeforeUnmount(() => emit('web-ident-change', false));
const route = useRoute();

const getPortalTitle = computed(() => {
  if (route.name === 'document-batch-sign') {
    return 'batch-identify-dialog-title';
  } else {
    return 'identify-dialog-title';
  }
});

const getPortalSubtitle = computed(() => {
  if (route.name === 'document-batch-sign') {
    return 'batch-identify-dialog-subtitle';
  } else {
    return 'identify-dialog-subtitle';
  }
});

const getPortalActions = computed(() => {
  if (route.name === 'document-batch-sign') {
    return 'batch-identify-dialog-actions';
  } else {
    return 'identify-dialog-actions';
  }
});

function closeDialog() {
  emit('close-dialog');
}

function getApp() {
  if (
    deepAdminInternalStore.userValidations &&
    deepAdminInternalStore.userValidations.slice(-1)[0].url
  ) {
    window.open(
      deepAdminInternalStore.userValidations.slice(-1)[0].url,
      '_self'
    );
  } else {
    closeDialog();
  }
}
</script>

<style scoped lang="scss">
.authority-service-logo {
  height: 20px;
}
</style>
